<template>
  <base-form :can-back="canBack">
    <slot />
    <template #submit-button>
      <slot name="submit-button" />
    </template>
  </base-form>
</template>

<script>
import BaseForm from '@/views/templates/forms/BaseForm'

export default {
  name: "PlainForm",
  components: {
    BaseForm,
  },
  props: {
    canBack: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
